import { goto, preloadCode } from '$app/navigation'
import { track } from './track'

export async function HandlePreloadBlock(
	blockId: string,
	tripId: string,
	parentId: string,
	isBrowser: boolean,
	isPublic: boolean = false,
	itineraryId: string = null,
) {
	track('Preload Block', { tripId, blockId, parentId })

	const url = BuildBlockUrl(tripId, blockId, parentId, isPublic, itineraryId)

	if (isBrowser) {
		return preloadCode(url.toString())
	}
}

export async function HandleBlockClick(
	blockId: string,
	tripId: string,
	parentId: string,
	isBrowser: boolean,
	isPublic: boolean = false,
	itineraryId: string = null,
) {
	track('View Block', { tripId, blockId, parentId })

	const url = BuildBlockUrl(tripId, blockId, parentId, isPublic, itineraryId)

	if (isBrowser) {
		return goto(url, { keepFocus: false })
	}
}

function BuildBlockUrl(
	tripId: string,
	blockId: string,
	parentId: string,
	isPublic: boolean = false,
	itineraryId: string = null,
) {
	const origin = window.location.origin
	let newUrl = `/trips/${tripId}/${blockId}`

	if (isPublic) {
		newUrl = `/explore/${tripId}/${blockId}`
	}

	const url = new URL(newUrl, origin)

	if (parentId != null) {
		url?.searchParams?.set('parent', parentId)
	} else {
		url?.searchParams?.delete('parent')
	}

	if (itineraryId != null) {
		url?.searchParams?.set('itinerary', itineraryId)
	} else {
		url?.searchParams?.delete('itinerary')
	}

	const currentUrl = new URL(window.location.href)
	const fullscreenParam = currentUrl.searchParams.get('fullscreen')
	if (fullscreenParam !== null) {
		url.searchParams.set('fullscreen', fullscreenParam)
	}

	return url
}

export async function HandleHighlightClick(
	blockId: string,
	tripId: string,
	parentId: string,
	isBrowser: boolean,
	isPublic: boolean = false,
	itineraryId: string = null,
) {
	track('View Highlights', { tripId, blockId, parentId })

	const origin = window.location.origin
	let newUrl = `/trips/${tripId}/highlights`

	if (isPublic) {
		newUrl = `/explore/${tripId}/highlights`
	}

	const url = new URL(newUrl, origin)

	if (parentId != null) {
		url?.searchParams?.set('parent', parentId)
	} else {
		url?.searchParams?.delete('parent')
	}

	if (itineraryId != null) {
		url?.searchParams?.set('itinerary', itineraryId)
	} else {
		url?.searchParams?.delete('itinerary')
	}

	if (blockId != null) {
		url?.searchParams?.set('active', blockId)
	} else {
		url?.searchParams?.delete('active')
	}

	if (isBrowser) {
		return goto(url, { keepFocus: false })
	}
}

export function HandleCloseBlockPage(
	tripId: string,
	parentId: string,
	isBrowser: boolean,
	isPublic: boolean = false,
	itineraryId: string = null,
) {
	track('Close Block Page', { tripId })

	const origin = window.location.origin
	let newUrl = `/trips/${tripId}`

	if (isPublic) {
		newUrl = `/explore/${tripId}`
	}

	const url = new URL(newUrl, origin)

	if (parentId != null) {
		url?.searchParams?.set('parent', parentId)
	} else {
		url?.searchParams?.delete('parent')
	}

	if (itineraryId != null) {
		url?.searchParams?.set('itinerary', itineraryId)
	} else {
		url?.searchParams?.delete('itinerary')
	}

	const currentUrl = new URL(window.location.href)
	const fullscreenParam = currentUrl.searchParams.get('fullscreen')
	if (fullscreenParam !== null) {
		url.searchParams.set('fullscreen', fullscreenParam)
	}

	if (isBrowser) {
		goto(url, { keepFocus: false })?.then(() => {
			// console.log('close block page')
			// blockState.clearAllCustom()
		})
	}
}

export async function HandlePageChange(
	tripId: string,
	parentId: string,
	isBrowser: boolean,
	pathname: string,
	itineraryId: string = null,
	panelState: string = null,
) {
	track('Change Panel State', {
		tripId,
		parentId,
		pathname,
		itineraryId,
	})

	const origin = window.location.origin
	const url = new URL(pathname, origin)

	// Handle parent ID
	if (parentId != null) {
		url.searchParams.set('parent', parentId)
	} else {
		url.searchParams.delete('parent')
	}

	// Handle itinerary ID
	if (itineraryId != null) {
		url.searchParams.set('itinerary', itineraryId)
	} else {
		url.searchParams.delete('itinerary')
	}

	// Handle panel state
	if (panelState) {
		url.searchParams.set('panel', panelState)
	} else {
		url.searchParams.delete('panel')
	}

	const currentUrl = new URL(window.location.href)
	const fullscreenParam = currentUrl.searchParams.get('fullscreen')
	if (fullscreenParam !== null) {
		url.searchParams.set('fullscreen', fullscreenParam)
	}

	if (isBrowser) {
		return goto(url, { keepFocus: false })
	}

	return url
}

export function setFullScreenParam(isFullScreen: boolean, isBrowser: boolean = true) {
	if (!isBrowser) return

	const url = new URL(window.location.href)
	url.searchParams.set('fullscreen', isFullScreen.toString())

	if (isBrowser) {
		goto(url, { keepFocus: false })
	}
}

export function removePanelState(
	pathname: string,
	isBrowser: boolean,
	itineraryId: string = null,
	activeBlockId: string = null,
) {
	const origin = window.location.origin
	const url = new URL(pathname, origin)
	url.searchParams.delete('panel')

	// Handle itinerary ID
	if (itineraryId != null) {
		url.searchParams.set('itinerary', itineraryId)
	} else {
		url.searchParams.delete('itinerary')
	}

	if (activeBlockId != null) {
		url.searchParams.set('active', activeBlockId)
	} else {
		url.searchParams.delete('active')
	}

	const currentUrl = new URL(window.location.href)
	const fullscreenParam = currentUrl.searchParams.get('fullscreen')
	if (fullscreenParam !== null) {
		url.searchParams.set('fullscreen', fullscreenParam)
	}

	if (isBrowser) {
		goto(url, { keepFocus: false })
	}
}
